import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../../apiConfig";
import linked from "../../assets/icons/Linkedin-2.webp";
import member1 from "../../assets/images/member-1.webp";
import member2 from "../../assets/images/member-2.webp";
import member3 from "../../assets/images/member-3.webp";
import member4 from "../../assets/images/member-4.webp";
import member5 from "../../assets/images/member-5.webp";
import member6 from "../../assets/images/member-6.webp";
import memberPlaceholder from "../../assets/images/member-placeholder.svg";
import "./membersStyles.scss";

const Members = () => {
  const fallbackMembers = [
    {
      id: 1,
      name: "Bimsara Gamage",
      pos: "Managing Director/ CEO",
      quote:
        "Although we are in the service provider business, I always visualize our operation similar to a production process in the manufacturing industry that runs on a conveyor belt system. The seamless flow of perfect coordination between departments ensuring efficiency with stringent quality checks at all points, I believe, is the greatest strength we have built as a team now.",
      des: "Bimsara counts over 15 years of experience involving hundreds of Real Estate mediation as a licensed broker and an auctioneer. His initial entry was as an investor and a developer and that involvement has made him conversant with all legal procedures as well as local authority and UDA regulations.",
      des2: "Bimsara has been tested in many environments for honesty and integrity and the testimonials issued by his real estate clients speak volumes of Bimsara's ability, capacity, passion and his uncompromising commitment to rise to the top in the real estate business.",
      img: member1,
      link: "https://www.linkedin.com/in/bimsara-b-gamage-5b0b832a/",
    },
    { id: 2, name: "Vinuri Liyanagamage", pos: "Head of Operations", quote: "I see the company as far more than a real estate broker but is a responsible and ethical body that is well specialized in treating the data right with the intention of producing the right outcome.", des: "Vinuri works towards achieving company objectives by overseeing all operations, managing people, implementing tech solutions and it doesn't end there!", des2: "She relentlessly dedicated her time in studying the business processes of this unique industry to re-engineer the processes & better serve our clients by embracing tech.", img: member2, link: "https://www.linkedin.com/in/vinuri-liyanagamage" },
    { id: 3, name: "Evantha Divulwewa", pos: "Manager - Transactions", quote: "I believe that with the quality of work & ethics of the company that are inculcated to a small team, we are delivering a service way above the industry standards. In this backdrop, continuous guidance and our adaptability will enable me to grow my career further and the company to achieve its objectives.", des: "Evantha is entrusted with the responsibility of a vital phase in the business process; managing and coordinating confirmed sales leading to a successful and efficient close. He is the key facilitator for multiple parties involved in all transactions.", des2: "Although he comes from a different industry having obtained his degree in the Hospitality Trade, with the constant guidance and mentoring, he made a fine and a responsible business manager for the company.", img: member3, link: "https://lk.linkedin.com/in/evantha-divulwewa-b9007690" },
    { id: 4, name: "Punsiri Wijekoon", pos: "Field Coordinator", quote: "The company is a place for self-improvement. I enjoy great benefits and work-life balance here at Safetynet.", des: "Punsiri is a front-liner of Safetynet (Private) Limited. He facilitates client visits and gets involved in the initial property evaluation and grading.", des2: "He comes with accountancy and procurement experience. Our property procurement process is much influenced by his contribution in helping to better understand the nature and status of the properties strictly maintaining the compliance standards set by the management.", img: member4, link: "https://www.linkedin.com/in/punsiri-wijekoon-745b6579/" },
    { id: 5, name: "Hansi Ranasinghe", pos: "Division Manager - Apartments", quote: "The company has made the brand name by not only analyzing the situations correctly but also timely forecasting the opportunities available with the market trends. The experience gained by handling a property as a project is the best practice a broking company can promote to its employees.", des: "Hansi comes with hands-on experience and knowledge in sales and marketing. She manages the apartments division overlooking property procurement, marketing activities and sales. Her level of attention to detail serves well in identifying the requirements of the clients to provide them the best solutions while adding value by saving their valuable time.", des2: "Hansi holds a BSc in Industrial Management and Statistics. Currently she is reading for her Masters in Applied Statistics.", img: member5, link: "https://www.linkedin.com/in/hansi-gangadhari-ranasinghe-5968b9163" },
    { id: 6, name: "Nadeesha Weerathunga", pos: "Division Manager - Houses", quote: "Aiming at increasing the productivity and establishing the credentials as a Real Estate industry expert by improving the skills and providing better service to the customers.", des: "Nadeesha manages the houses division overlooking property procurement, marketing activities and sales. She comes with research experience and adds value to each project through that.", des2: "Nadeesha holds BSc(Special) in Agricultural Technology and Management and loves social service. She believes that ongoing practice, reading, reflection, asking for feedback and integrating them into behavior are crucial to become successful in achieving.", img: member6, link: "https://www.linkedin.com/in/nadeesha-weerathunga-8535421a6" },
  ];

  const [members, setMembers] = useState([]);
  const [selected, setSelected] = useState(fallbackMembers[0]);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/team-members`);
        const normalized = (response.data || []).map((member) => ({
          ...member,
          quote: member.description1 || "",
          des: member.description2 || "",
          des2: "",
          pos: member.position || member.pos || "",
          img: member.photo_path ? `${API_URL}${member.photo_path}` : memberPlaceholder,
          link: member.linkedin_url || member.link || "",
        }));

        if (normalized.length > 0) {
          setMembers(normalized);
          setSelected(normalized[0]);
        } else {
          setMembers(fallbackMembers);
          setSelected(fallbackMembers[0]);
        }
      } catch (error) {
        setMembers(fallbackMembers);
        setSelected(fallbackMembers[0]);
      }
    };

    fetchMembers();
  }, []);

  const data = members.length > 0 ? members : fallbackMembers;

  return (
    <div className="Members_component">
      <div className="members-stage">
        <ul className="circle-container">
          {data
            .slice(0, 12)
            .filter((memb) => memb.id !== selected.id)
            .map((memb) => (
              <li key={memb.id}>
                <img src={memb.img} alt={memb.name} onClick={() => setSelected(memb)} />
              </li>
            ))}
        </ul>

        {/* key forces remount on selection change, triggering the fade-in animation */}
        <div className="inner-circle" key={selected.id}>
          <div className="member-detail">
            <div className="inner-circle-main">
              <img src={selected.img} alt="" />
              {selected.link && (
                <a href={selected.link} target="_blank" rel="noopener noreferrer" style={{ cursor: "pointer", zIndex: 1 }}>
                  <img alt="LinkedIn" src={linked} className="linked" />
                </a>
              )}
            </div>
            <div className="member-name">{selected.name}</div>
            <div className="member-designation">{selected.pos}</div>
            <div className="member-text-scroll">
              <div className="member-quote">{selected.quote}</div>
              <div className="member-description">
                {selected.des}
                {selected.des2 && (
                  <>
                    <br />
                    {selected.des2}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Members;
